<script lang="ts">
	import { page } from '$app/state';
	import Blok from '$lib/storyblok/blok.svelte';
	import { hasReference, withSlugs } from '$lib/utils/storyblok/page';
	import type { ISbStoryData } from '@storyblok/js';
	import { onMount } from 'svelte';
	import { storyblok } from '$lib/state/storyblok.svelte';
	interface EmailCaptureData {
		pages: string[];
		enabled: boolean;
		content: Array<ISbStoryData['content']>;
	}

	let emailCapture = $state<ISbStoryData<EmailCaptureData>['content']>();

	onMount(async () => {
		const response = await storyblok.client.getStory<EmailCaptureData>('globals/email-capture', {
			resolve_relations: 'pages'
		});

		emailCapture = withSlugs(response).content;
	});
</script>

{#if emailCapture && hasReference(emailCapture.pages, page.url.pathname)}
	{#each emailCapture.content || [] as content}
		<Blok {content} />
	{/each}
{/if}
